/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import { GrabXRUMConfig } from "grabx/types"

export const DEFAULT_IGNORE_ERROR_MESSAGES = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
  "zaloJSV2",
]

export const DEFAULT_DATADOG_RUM_CONFIG: GrabXRUMConfig = {
  sampleRate: 20,
  sessionReplaySampleRate: 0,
  defaultPrivacyLevel: "mask",
  trackLongTasks: true,
  trackUserInteractions: false,
  trackResources: true,
  ignoreErrorMessages: DEFAULT_IGNORE_ERROR_MESSAGES,
}

export function getIgnoreErrorMessagesRegex(
  config?: Pick<GrabXRUMConfig, "ignoreErrorMessages">,
): RegExp[] {
  try {
    // note: no errors should occur here, but adding a try-catch for extra safety in case ignoreErrorMessages turns out to be an invalid array
    const ignoreErrorMessages =
      config?.ignoreErrorMessages ?? DEFAULT_IGNORE_ERROR_MESSAGES
    return ignoreErrorMessages
      .map(e => {
        try {
          const compiledRegex = new RegExp(e)
          return compiledRegex
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(
            "Error compiling individual regex entry from config. Skipping.",
            error,
          )
          return undefined
        }
      })
      .filter(e => e !== undefined) as RegExp[]
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error compiling regex from config. Skipping.", error)
    return []
  }
}
